import {GameFilterDefinitionBase} from "./game-filter-definition-base";
import {GameInfo} from "../../games/game-info";
import {ApplyGameFilterResult} from "../evaluators/game-filter-evaluator.interface";

export abstract class GameGroupFilterDefinitionBase extends GameFilterDefinitionBase {
    protected abstract get gameGroupsIdsToFilterFor(): number[];

    applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {
        if(this.gameGroupsIdsToFilterFor.includes(gameInfo.gameGroupId)) {
            return ApplyGameFilterResult.IncludeGame;
        }

        return ApplyGameFilterResult.ExcludeGame;
    }
}